/* cache-bust 2026-06-19 — per-variant gallery */
/* ============================================================
   Soxee™ PDP — interakcje
   - Ikony, generator wzorów (pastylki) i SVG skarpety
   - Bundle selektor (1 para vs 1+1 GRATIS) + dropdowny per para
   - HIW: przełączanie tabów (sekcje server-rendered)
   - Akordeony, stepper, sticky ATC, toast
   - Add to cart przez Shopify Cart AJAX API z fallbackiem
   - Hot-reload na shopify:section:load
   Wszystkie kontenery sprawdzane defensywnie — JS no-op'uje gdy
   sekcji nie ma na stronie.
   ============================================================ */
(function(){
"use strict";

/* ---------- ICONS (line-art, stroke=currentColor) ---------- */
const I = {
  search:'<path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"/><path d="m21 21-4.3-4.3"/>',
  user:'<path d="M20 21a8 8 0 0 0-16 0"/><circle cx="12" cy="8" r="4"/>',
  cart:'<path d="M5 7h14l-1.2 10.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/>',
  star:'<path d="M12 3.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8L12 17l-5.3 2.6 1-5.8L3.5 9.7l5.9-.9L12 3.5Z"/>',
  heart:'<path d="M12 20s-7-4.5-9.3-9C1.2 8 2.7 4.8 6 4.8c2 0 3.2 1.2 4 2.4.8-1.2 2-2.4 4-2.4 3.3 0 4.8 3.2 3.3 6.2C19 15.5 12 20 12 20Z"/>',
  gift:'<rect x="4" y="9" width="16" height="11" rx="1.5"/><path d="M4 13h16M12 9v11"/><path d="M12 9S10 4.5 7.5 5.2C5.8 5.7 6.4 9 9 9M12 9s2-4.5 4.5-3.8C18.2 5.7 17.6 9 15 9"/>',
  ruler:'<rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/>',
  plus:'<path d="M12 5v14M5 12h14"/>',
  minus:'<path d="M5 12h14"/>',
  check:'<path d="M5 12.5 10 17 19 7"/>',
  close:'<path d="M6 6l12 12M18 6 6 18"/>',
  chevron:'<path d="m6 9 6 6 6-6"/>',
  box:'<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z"/><path d="m3.5 7.5 8.5 4.6 8.5-4.6M12 21v-8.9"/>',
  truck:'<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/>',
  shield:'<path d="M12 3 5 6v5c0 4.2 2.9 7.6 7 9 4.1-1.4 7-4.8 7-9V6l-7-3Z"/><path d="m9 12 2 2 4-4"/>',
  chat:'<path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12Z"/>',
  sock:'<path d="M9 3h5v8.5c0 1 .3 1.6 1.2 2.4l2.6 2.3c1.6 1.4 1.5 4-.3 5.1-1.5 1-3.4.6-4.7-.6l-5-5c-1-1-1.4-2-1.4-3.4V3Z"/>',
  fabric:'<path d="M4 5h16v14H4z"/><path d="M4 9h16M4 13h16M4 17h16M9 5v14M14 5v14" opacity=".5"/>',
  leaf:'<path d="M5 19c0-8 5-13 14-13 0 9-5 14-14 13Z"/><path d="M5 19c3-5 6-7 10-8"/>',
  feather:'<path d="M19 5c-5 0-10 3-12 9l-3 5 5-3c6-2 9-7 9-12 0 0-4 1-6 3"/><path d="M11 13h5"/>',
  gauge:'<path d="M4 14a8 8 0 0 1 16 0"/><path d="M12 14l4-3"/><circle cx="12" cy="14" r="1.4" fill="currentColor" stroke="none"/>',
  clock:'<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  drop:'<path d="M12 3c3 4 6 7 6 10a6 6 0 0 1-12 0c0-3 3-6 6-10Z"/>',
  spark:'<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18"/>',
  arrow:'<path d="M5 12h14M13 6l6 6-6 6"/>'
};
function ico(name,cls){return '<svg viewBox="0 0 24 24" class="ico '+(cls||'')+'" aria-hidden="true">'+(I[name]||'')+'</svg>';}
window.__soxeeIco = ico;

/* ---------- PATTERN GENERATOR (pastylki / signature SVG tiles) ---------- */
function svgURI(inner, size){
  const s = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="'+size+'" height="'+size+'" viewBox="0 0 '+size+' '+size+'">'+inner+'</svg>');
  return "url('data:image/svg+xml,"+s+"')";
}
function petals(cx,cy,petal,center,r){let g='';for(let i=0;i<5;i++){const a=(i/5)*Math.PI*2-Math.PI/2;g+='<circle cx="'+(cx+Math.cos(a)*r).toFixed(1)+'" cy="'+(cy+Math.sin(a)*r).toFixed(1)+'" r="'+(r*.92).toFixed(1)+'" fill="'+petal+'"/>';}g+='<circle cx="'+cx+'" cy="'+cy+'" r="'+(r*.78).toFixed(1)+'" fill="'+center+'"/>';return g;}
function cluster(cx,cy,petal,center,sc){sc=sc||1;const r=3.4*sc;let g='';for(let i=0;i<5;i++){const a=(i/5)*Math.PI*2-Math.PI/2;g+='<circle cx="'+(cx+Math.cos(a)*r).toFixed(1)+'" cy="'+(cy+Math.sin(a)*r).toFixed(1)+'" r="'+(r*.85).toFixed(1)+'" fill="'+petal+'"/>';}g+='<circle cx="'+cx+'" cy="'+cy+'" r="'+(r*.7).toFixed(1)+'" fill="'+center+'"/>';return g;}
const PAT = {
  flowers:(bg,p,c)=>({size:40,inner:'<rect width="40" height="40" fill="'+bg+'"/>'+petals(20,20,p,c,7)}),
  ditsy:(bg,p,c)=>({size:48,inner:'<rect width="48" height="48" fill="'+bg+'"/>'+cluster(12,12,p,c,1)+cluster(36,36,p,c,1)+cluster(36,8,p,c,.8)+cluster(8,36,p,c,.8)}),
  dots:(bg,d)=>({size:30,inner:'<rect width="30" height="30" fill="'+bg+'"/><circle cx="9" cy="9" r="4" fill="'+d+'"/><circle cx="24" cy="24" r="4" fill="'+d+'"/>'}),
  finedots:(bg,d)=>({size:18,inner:'<rect width="18" height="18" fill="'+bg+'"/><circle cx="6" cy="6" r="2.3" fill="'+d+'"/><circle cx="15" cy="15" r="2.3" fill="'+d+'"/>'})
};
const tileCss=t=>svgURI(t.inner,t.size);
const C={sky:'#DCEDF8',blush:'#F9E3EA',mint:'#D8EFE4',lilac:'#E7DCF5',frost:'#EEF4F7',cream:'#FBF4E7',white:'#FFF',navy:'#13202E',aqua:'#14A0A6',rose:'#E59ABA',peri:'#AFC3E8',sage:'#8FC3A8',plum:'#9E7FC0',sun:'#F4C95D'};

/* fallback wzory (10 pastylek) — używane gdy produkt nie ma wariantów wzór/rozmiar */
const FALLBACK_VARIANTS = [
  {id:'kwiaty-biale',   name:'Kwiaty Białe',     tile:PAT.flowers(C.white, C.peri, C.sun)},
  {id:'kwiaty-rozowe',  name:'Kwiaty Różowe',    tile:PAT.flowers(C.blush, C.rose, C.white)},
  {id:'kwiaty-mietowe', name:'Kwiaty Miętowe',   tile:PAT.flowers(C.mint, C.sage, C.white)},
  {id:'kwiaty-lila',    name:'Kwiaty Lila',      tile:PAT.flowers(C.lilac, C.plum, C.white)},
  {id:'margerytki',     name:'Margerytki',       tile:PAT.flowers(C.sky, C.white, C.sun)},
  {id:'ditsy-pudrowy',  name:'Łączka Pudrowa',   tile:PAT.ditsy(C.cream, C.rose, C.aqua)},
  {id:'ditsy-blekit',   name:'Łączka Błękitna',  tile:PAT.ditsy(C.frost, C.peri, C.sun)},
  {id:'kropki-blekit',  name:'Kropki Błękit',    tile:PAT.dots(C.sky, C.white)},
  {id:'kropki-pudrowy', name:'Kropki Pudrowe',   tile:PAT.dots(C.blush, C.white)},
  {id:'kropki-granat',  name:'Kropki Granat',    tile:PAT.finedots(C.white, C.navy)}
];
FALLBACK_VARIANTS.forEach(v=>{ v.bg = tileCss(v.tile); });
const FALLBACK_SIZES = [{id:'sm',label:'S / M',foot:'rozm. 35–40'},{id:'lxl',label:'L / XL',foot:'rozm. 41–46'}];

/* Próbki wzoru (swatche SVG) — kafel na wariant, dopasowanie po nazwie. */
const PATTERN_TILES = {
  "corgi sky": { bg:'#6BA6E4', css:"#6BA6E4 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/s1_7a43c87b-6fb1-4c00-885f-a3e3a506a87a.png?width=450') 53.9% 10.8%/439.3% no-repeat" },
  "midnight garden": { bg:'#1F2634', css:"#1F2634 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/s1_336c779e-0479-4209-89e0-8b9f604f409b.png?width=450') 55.4% 23.2%/531.6% no-repeat" },
  "blue daisy": { bg:'#8FC7EA', css:"#8FC7EA url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/u1_a7c3c740-7877-43f0-9b6e-3e4a7fbe610e.png?width=450') 64.9% 74.6%/624.4% no-repeat" },
  "heartbeat": { bg:'#FBFBF7', css:"#FBFBF7 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/t1_2af476fe-beaf-4303-a558-b0a135718446.png?width=450') 57.5% 16.6%/527.2% no-repeat" },
  "mint cactus": { bg:'#B7E6D3', css:"#B7E6D3 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/r1_07e6c133-0a53-4913-80e9-2ff72cee5bf0.png?width=450') 56.1% 28.4%/440.9% no-repeat" },
  "vintage flowers": { bg:'#9FB0BE', css:"#9FB0BE url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/w1_1bfb315a-ec28-47ab-8a41-d63f2c93dfb3.png?width=450') 45.2% 11.8%/526.8% no-repeat" },
  "botanical": { bg:'#C6E4B7', css:"#C6E4B7 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/c2_86475166-8af9-4445-8733-bf582c883ad9.png?width=450') 21.5% 19.4%/359.9% no-repeat" },
  "spring blossom": { bg:'#F1EBDA', css:"#F1EBDA url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/y1.png?width=450') 53% 27.4%/622.9% no-repeat" },
  "blush bloom": { bg:'#F0C6D2', css:"#F0C6D2 url('https://cdn.shopify.com/s/files/1/0995/9325/7304/files/p1_09baad14-0eab-4d93-a3a8-748d18d30445.png?width=450') 51.9% 15.5%/437.6% no-repeat" }
};

/* ---------- VARIANTS: build from product data if available, else fallback ---------- */
function buildVariantData(){
  const data = window.__soxeeHeroData;
  if(data && data.variants && data.variants.length){
    const patternMap = new Map();
    const sizeMap = new Map();
    data.variants.forEach(v=>{
      if(v.option1){
        const id = (v.option1+'').toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
        if(!patternMap.has(id)){
          const tileDef = PATTERN_TILES[(v.option1+'').toLowerCase()];
          const match = FALLBACK_VARIANTS.find(fv=>fv.name.toLowerCase()===v.option1.toLowerCase());
          patternMap.set(id, {
            id, name:v.option1,
            tile: match ? match.tile : null,
            // swatch: kafel wzoru po nazwie → stary wzór z fallbacku → (dalej zdjęcie/domyślny w renderze)
            bg: tileDef ? tileDef.css : (match ? match.bg : null),
            featuredImage: v.featured_image || null,
            featuredMediaId: v.featured_media_id || null
          });
        }
      }
      if(v.option2){
        const id = (v.option2+'').toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
        if(!sizeMap.has(id)) sizeMap.set(id, {id, label:v.option2, foot:''});
      }
    });
    const variants = [...patternMap.values()];
    const sizes = [...sizeMap.values()];
    if(variants.length>0){
      const lookup = {};
      data.variants.forEach(v=>{
        const key = (v.option1||'')+'||'+(v.option2||'');
        lookup[key.toLowerCase()] = v;
        // produkt bez rozmiaru: indeks też po samym wzorze/kolorze
        if(!v.option2) lookup[((v.option1||'')+'||').toLowerCase()] = v;
      });
      // gdy produkt nie ma realnej opcji rozmiaru — pokazujemy domyślny selektor S/M, L/XL (UI),
      // a koszyk i tak dobiera wariant po kolorze (sizesReal=false)
      const sizesReal = sizes.length > 0;
      return {variants, sizes: sizesReal ? sizes : FALLBACK_SIZES, lookup, real:true, sizesReal};
    }
  }
  return {variants:FALLBACK_VARIANTS, sizes:FALLBACK_SIZES, lookup:null, real:false, sizesReal:false};
}
const VD = buildVariantData();
const VARIANTS = VD.variants;
const SIZES = VD.sizes;
const VARIANT_LOOKUP = VD.lookup;
const USING_REAL_VARIANTS = VD.real;
const SIZES_REAL = VD.sizesReal;
/* dobiera realny wariant Shopify po kolorze (+ rozmiarze gdy rozmiar jest realną opcją) */
function realVariantFor(colorName, sizeLabel){
  if(!VARIANT_LOOKUP || !colorName) return null;
  const c = colorName.toLowerCase();
  if(SIZES_REAL && sizeLabel){
    const hit = VARIANT_LOOKUP[(c+'||'+sizeLabel.toLowerCase())];
    if(hit) return hit;
  }
  return VARIANT_LOOKUP[(c+'||')] || null;
}

/* ---------- COLOR SWATCHES (proste kolory → realny kolor, nie kafelek SVG) ---------- */
const COLOR_HEX = {
  'grey':'#9aa0a6','gray':'#9aa0a6','szary':'#9aa0a6',
  'black':'#1c1c1e','czarny':'#1c1c1e','czarne':'#1c1c1e',
  'white':'#ffffff','bialy':'#ffffff','biale':'#ffffff',
  'pink':'#f3a3c0','rozowy':'#f3a3c0','rozowe':'#f3a3c0',
  'beige':'#e3d4bd','bezowy':'#e3d4bd','bezowe':'#e3d4bd',
  'navy':'#1f3a5f','granat':'#1f3a5f','granatowy':'#1f3a5f',
  'blue':'#6fa8dc','niebieski':'#6fa8dc','blekit':'#9ec5e8','blekitny':'#9ec5e8',
  'mint':'#b7e4cf','mietowy':'#b7e4cf','mieta':'#b7e4cf',
  'lilac':'#cdbce8','lila':'#cdbce8','fioletowy':'#b79de0',
  'cream':'#f5ead6','krem':'#f5ead6','kremowy':'#f5ead6',
  'red':'#d64545','czerwony':'#d64545','green':'#6fae7a','zielony':'#6fae7a',
  'yellow':'#f4c95d','zolty':'#f4c95d','brown':'#8a5a3b','brazowy':'#8a5a3b',
  'nude':'#e7c9b1','sand':'#e3d4bd','piaskowy':'#e3d4bd'
};
function colorHex(name){
  const k=(name||'').toString().toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g,'').trim();
  /* Wzór nigdy nie jest kolorem jednolitym: colorHex rozbija nazwę na słowa, więc "Blue Daisy" łapało się na "blue", a "Mint Cactus" na "mint" — i te dwa wzory renderowały się jako płaskie kółka koloru zamiast próbki. */
  if(PATTERN_TILES[k]) return null;
  if(COLOR_HEX[k]) return COLOR_HEX[k];
  const word = k.split(/[\s\/_-]+/).find(w=>COLOR_HEX[w]);
  return word ? COLOR_HEX[word] : null;
}
VARIANTS.forEach(v=>{ v.solid = colorHex(v.name); });

/* ---------- PER-VARIANT MEDIA (galeria zmienia się przy wyborze wzoru) ---------- */
const MEDIA = (window.__soxeeHeroData && window.__soxeeHeroData.media) || [];
const norm = s => (s||'').toString().toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g,'').trim();
/* Kolejność w galerii wariantu = liczba w tekście alternatywnym po nazwie wariantu.
   Np. „Grey 1”, „Grey 2” … ustawiają porządek; alt bez liczby („Grey”, „Grey — cechy”)
   trafia na koniec, zachowując kolejność mediów produktu. Zmieniasz kolejność edytując alt. */
function orderIndex(alt, key){
  const rest = norm(alt).split(key).join(' ');
  const m = rest.match(/\d+/);
  return m ? parseInt(m[0], 10) : Infinity;
}
function mediaForVariant(v){
  if(!v || !MEDIA.length) return [];
  const key = norm(v.name);
  let list = key ? MEDIA.filter(m => norm(m.alt).includes(key)) : [];
  if(!list.length && v.featuredMediaId) list = MEDIA.filter(m => m.id === v.featuredMediaId);
  // sortowanie stabilne po numerze w alt (bez numeru → koniec, w kolejności mediów)
  return list
    .map((m, i) => ({ m, i, o: orderIndex(m.alt, key) }))
    .sort((a, b) => (a.o !== b.o ? a.o - b.o : a.i - b.i))
    .map(x => x.m);
}
/* feature aktywuje się tylko gdy realne warianty + co najmniej jeden wzór ma dopasowane media po ALT */
const HAS_VARIANT_MEDIA = USING_REAL_VARIANTS && MEDIA.length > 0 && VARIANTS.some(v => {
  const key = norm(v.name);
  return key && MEDIA.some(m => norm(m.alt).includes(key));
});
/* Galeria zawężona do realnych wariantów: aktywna gdy są realne warianty i którykolwiek
   ma media (po ALT lub przypisane featured). Wtedy NIE pokazujemy wspólnej, wymieszanej galerii. */
const VARIANT_GALLERY_ON = USING_REAL_VARIANTS && (HAS_VARIANT_MEDIA || VARIANTS.some(v => v.featuredMediaId));
/* Podmiana głównego zdjęcia: crossfade + dopasowanie kadru do proporcji pliku.
   Proporcje ustawiamy dopiero po load, bo naturalWidth/Height są znane dopiero wtedy;
   stare zdjęcie usuwamy po przejściu, żeby nie mrugało pustym tłem. */
function setMainImage(fill, url, alt){
  if(!fill || !url) return;
  const main = fill.closest('.gallery__main') || fill.parentElement;
  // Znacznik kolejności. renderGalleryForVariant() woła się więcej niż raz, więc
  // dwa wczytania potrafią się ścigać — bez tego strażnika sprzątanie po wolniej
  // wczytanym obrazku kasowało ten nowszy i galeria zostawała pusta.
  const seq = String((parseInt(fill.dataset.seq || '0', 10) + 1));
  fill.dataset.seq = seq;
  const img = new Image();
  img.alt = (alt||'')+'';
  img.decoding = 'async';
  img.addEventListener('load', function(){
    if(fill.dataset.seq !== seq){ img.remove(); return; }   // wyprzedzone przez nowsze żądanie
    if(main && img.naturalWidth && img.naturalHeight){
      main.style.setProperty('--sx-ar', img.naturalWidth+' / '+img.naturalHeight);
    }
    const prev = Array.prototype.slice.call(fill.querySelectorAll('img')).filter(function(x){ return x!==img; });
    requestAnimationFrame(function(){ img.classList.add('is-in'); });
    setTimeout(function(){
      if(fill.dataset.seq !== seq) return;
      prev.forEach(function(p){ p.remove(); });
    }, 400);
  }, { once:true });
  img.addEventListener('error', function(){ img.remove(); }, { once:true });
  fill.appendChild(img);
  img.src = url;
}

function renderGalleryForVariant(){
  const main=$('#sx-gmain'); if(!main) return;
  const v=VARIANTS.find(x=>x.id===state.variant)||VARIANTS[0];
  const list=mediaForVariant(v);
  if(!list.length){ renderHeroSockFallback(); return; }
  main.querySelector('.shot-wrap')?.remove();
  main.style.background='';
  let fill=main.querySelector('.sx-media-fill');
  if(!fill){ fill=document.createElement('div'); fill.className='sx-media-fill'; main.appendChild(fill); }
  setMainImage(fill, list[0].full, (list[0].alt||v.name));
  const thumbs=$('#sx-gthumbs');
  if(thumbs){
    thumbs.innerHTML=list.map((m,i)=>'<button class="thumb'+(i===0?' is-active':'')+'" data-i="'+i+'" data-media-type="'+(m.type||'image')+'" data-full="'+m.full+'" data-alt="'+((m.alt||'')+'').replace(/"/g,'&quot;')+'" aria-label="Miniatura '+(i+1)+'"><div class="shot"><img src="'+m.thumb+'" loading="lazy" alt=""></div></button>').join('');
  }
}

/* ---------- SOCK ILLUSTRATION ---------- */
const SOCK='M70 20h58a11 11 0 0 1 11 11v90c0 10 3 16 12 23l28 21c18 13 15 41-6 50-15 7-33 3-45-8l-56-49c-11-10-16-21-16-35V31a11 11 0 0 1 14-11Z';
function shotBlock(variantId,label){
  const v = VARIANTS.find(x=>x.id===variantId) || VARIANTS[0];
  if(!v||!v.tile) return '';
  const cid='sk'+Math.random().toString(36).slice(2,7);
  const t=v.tile;
  const svg=
  '<svg class="sock-illustration" viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'+
    '<defs>'+
      '<pattern id="p'+cid+'" patternUnits="userSpaceOnUse" width="'+t.size+'" height="'+t.size+'">'+t.inner+'</pattern>'+
      '<clipPath id="c'+cid+'"><path d="'+SOCK+'"/></clipPath>'+
      '<filter id="s'+cid+'" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="10" stdDeviation="10" flood-color="#13202E" flood-opacity="0.14"/></filter>'+
    '</defs>'+
    '<g filter="url(#s'+cid+')">'+
      '<g clip-path="url(#c'+cid+')">'+
        '<rect x="40" y="10" width="200" height="230" fill="url(#p'+cid+')"/>'+
        '<rect x="40" y="20" width="200" height="26" fill="rgba(19,32,46,.05)"/>'+
        '<path d="M70 122c20 8 44 8 70 2" stroke="rgba(19,32,46,.06)" stroke-width="14" fill="none"/>'+
      '</g>'+
      '<path d="'+SOCK+'" fill="none" stroke="rgba(19,32,46,.18)" stroke-width="2.5"/>'+
      '<path d="M70 46h58" stroke="rgba(19,32,46,.14)" stroke-width="2"/>'+
    '</g>'+
  '</svg>';
  return '<div class="shot">'+svg+(label?'<span class="shot__label">'+label+'</span>':'')+'</div>';
}
const TINTS=['#DCEDF8','#F9E3EA','#D8EFE4','#E7DCF5','#EEF4F7'];

/* ============================================================
   RENDER
   ============================================================ */
const $=(s,r)=>(r||document).querySelector(s);
const $$=(s,r)=>[...(r||document).querySelectorAll(s)];
const state={ offer:'bogo', variant:VARIANTS[0]?.id, variant2:VARIANTS[1]?.id||VARIANTS[0]?.id, size1:SIZES[0]?.id||null, size2:SIZES[0]?.id||null, qty:1 };

/* ---------- LINK DO KONKRETNEGO WZORU ----------
   PDP w ogóle nie czytał ?variant= — wejście z linku do wzoru pokazywało
   pierwszy wariant (adres mówił co innego niż strona), a klik we wzór nie
   zmieniał adresu, więc nie dało się skopiować linku do tego, co się widzi.
   Poniższe domyka obie strony: wejście z linku ustawia wzór i rozmiar,
   a każda zmiana aktualizuje adres (replaceState — bez zaśmiecania historii). */
function slugOf(x){ return (x+'').toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,''); }

function urlForVariant(patternId, sizeId){
  const p = VARIANTS.find(x=>x.id===patternId);
  const sz = SIZES.find(x=>x.id===sizeId);
  const rv = p ? realVariantFor(p.name, sz ? sz.label : null) : null;
  return rv ? (location.pathname + '?variant=' + rv.id) : location.pathname;
}

function syncVariantUrl(){
  if(!USING_REAL_VARIANTS || !window.history || !history.replaceState) return;
  const p = VARIANTS.find(x=>x.id===state.variant);
  const sz = SIZES.find(x=>x.id===state.size1);
  const rv = p ? realVariantFor(p.name, sz ? sz.label : null) : null;
  if(!rv) return;
  // Podmieniamy WYŁĄCZNIE parametr variant, reszta zostaje. Wcześniej adres był
  // składany od zera, więc pierwszy klik we wzór kasował utm_source/utm_campaign
  // i inne parametry z linku reklamowego.
  let qs;
  try { qs = new URLSearchParams(location.search); } catch(e){ return; }
  if(qs.get('variant') === String(rv.id)) return;
  qs.set('variant', rv.id);
  try { history.replaceState(null, '', location.pathname + '?' + qs.toString()); } catch(e){}
}

function applyVariantFromUrl(){
  let raw = null;
  try { raw = new URLSearchParams(location.search).get('variant'); } catch(e){ return; }
  if(!raw) return;
  const data = window.__soxeeHeroData;
  const hit = data && data.variants && data.variants.find(v=>String(v.id)===String(raw));
  if(!hit) return;
  const p = slugOf(hit.option1||'');
  const sz = slugOf(hit.option2||'');
  if(p && VARIANTS.some(v=>v.id===p)){ state.variant=p; state.variant2=p; state.variants=[p,p]; }
  if(sz && SIZES.some(x=>x.id===sz)){ state.size1=sz; state.size2=sz; state.sizes=[sz,sz]; }
}
applyVariantFromUrl();

/* ---------- BUNDLE (oferta + wzór i rozmiar per para) ---------- */
const OFFERS=[
  {id:'single', title:'1 para', sub:'Jedna para w standardowej cenie', price: window.__soxeeHeroData?.price || '129,99 zł', old:'', pairs:1, paid:1, flag:''},
  {id:'bogo', title:'Kup 1 + 1 GRATIS', sub:'', price: window.__soxeeHeroData?.price || '129,99 zł', old: window.__soxeeHeroData?.comparePrice || '259,98 zł', pairs:2, paid:1, flag:'Najczęściej wybierane'},
  {id:'mega', title:'Kup 2 + 3 GRATIS', sub:'5 par w cenie 2 — oszczędzasz 390 zł', price:'259,98 zł', old:'649,95 zł', pairs:5, paid:2, flag:'Najlepsza wartość'}
];
function chev(){return '<svg viewBox="0 0 24 24" class="dd__chev"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';}
function ddHTML(key,current,items,isSize){
  const cur=items.find(o=>o.val===current);
  const valTxt=cur?(cur.label+(cur.sub?'<small>'+cur.sub+'</small>':'')):(isSize?'Wybierz rozmiar':'Wybierz wzór');
  const sw=(!isSize&&cur&&cur.sw)?'<span class="dd__sw" style="background:'+cur.sw+'"></span>':'';
  const menu=items.map(o=>'<button class="dd__opt'+(o.val===current?' sel':'')+'" type="button" data-val="'+o.val+'">'+
    ((!isSize&&o.sw)?'<span class="dd__sw" style="background:'+o.sw+'"></span>':'')+
    '<span>'+o.label+(o.sub?' <small>'+o.sub+'</small>':'')+'</span></button>').join('');
  return '<div class="dd'+(isSize?' dd--size':'')+'" data-dd="'+key+'">'+
    '<button class="dd__btn" type="button" aria-haspopup="listbox">'+sw+
    '<span class="dd__val">'+valTxt+'</span>'+chev()+'</button>'+
    '<div class="dd__menu" role="listbox">'+menu+'</div></div>';
}
function renderBundle(){
  const box=$('#sx-bundle'); if(!box)return;
  const patItems=VARIANTS.map(v=>({val:v.id,label:v.name,sw:v.solid||v.bg}));
  const sizeItems=SIZES.map(s=>({val:s.id,label:s.label,sub:s.foot}));
  box.innerHTML=OFFERS.map(o=>{
    const active=state.offer===o.id;
    let h='<div class="bundle-opt'+(active?' is-active':'')+(o.flag?' bundle-opt--featured':'')+'" data-offer="'+o.id+'">';
    if(o.flag) h+='<span class="bundle-flag">'+o.flag+'</span>';
    h+='<button class="bundle-opt__head" type="button" data-pick="'+o.id+'" aria-pressed="'+active+'">'+
        '<span class="bundle-radio"></span>'+
        '<span class="bundle-opt__main"><span class="bundle-opt__title">'+o.title+'</span>'+
          (o.sub?'<span class="bundle-opt__sub">'+o.sub+'</span>':'')+'</span>'+
        '<span class="bundle-opt__price"><b>'+o.price+'</b>'+(o.old?'<s>'+o.old+'</s>':'')+'</span>'+
      '</button>';
    if(active){
      h+='<div class="bundle-config">';
      const sv=state.variants||[];
      const ss=state.sizes||[];
      for(let i=0;i<o.pairs;i++){
        const pv = sv[i] || (i===0 ? state.variant : (i===1 ? state.variant2 : null));
        const ps = ss[i] || (i===0 ? state.size1 : (i===1 ? state.size2 : null)) || (SIZES[0] && SIZES[0].id);
        const sizeDD = SIZES.length ? ddHTML('size'+i,ps,sizeItems,true) : '';
        h+='<div class="pair"><span class="pair__num">'+(o.pairs>1?('#'+(i+1)):ico('sock'))+'</span>'+
           '<div class="pair__sel">'+ddHTML('pat'+i,pv,patItems,false)+sizeDD+'</div></div>';
      }
      h+='</div>';
    }
    return h+'</div>';
  }).join('');
}
function closeAllDD(){ $$('#sx-bundle .dd.open').forEach(d=>d.classList.remove('open')); }
function applyBundle(key,val){
  if(key.startsWith('pat')){
    const idx=parseInt(key.replace('pat',''));
    state.variants=state.variants||[];
    state.variants[idx]=val;
    if(idx===0) state.variant=val;
    else if(idx===1) state.variant2=val;
  } else if(key.startsWith('size')){
    const idx=parseInt(key.replace('size',''));
    state.sizes=state.sizes||[];
    state.sizes[idx]=val;
    if(idx===0) state.size1=val;
    else if(idx===1) state.size2=val;
  }
  renderBundle();
  if(key==='pat0'){
    const v=VARIANTS.find(x=>x.id===val);
    if(v){
      const lbl=$('#sx-vp-name');if(lbl)lbl.textContent=v.name;
      syncSticky();
      renderHeroSockFallback();
      renderVariantPicker();
    }
  }
  if(USING_REAL_VARIANTS) syncShopifyVariantId();
}
function syncShopifyVariantId(){
  if(!VARIANT_LOOKUP) return;
  const sel = $('#sx-variant-id'); if(!sel) return;
  const p1 = VARIANTS.find(v=>v.id===state.variant)?.name;
  const s1 = SIZES.find(s=>s.id===state.size1)?.label;
  const v = realVariantFor(p1, s1);
  if(v) sel.value = v.id;
  syncVariantUrl();
}
function wireBundleOnce(){
  const box=$('#sx-bundle'); if(!box || box.dataset.wired)return;
  box.dataset.wired='1';
  box.addEventListener('click',e=>{
    const opt=e.target.closest('.dd__opt');
    if(opt){applyBundle(opt.closest('.dd').dataset.dd,opt.dataset.val);return;}
    const btn=e.target.closest('.dd__btn');
    if(btn){const dd=btn.closest('.dd');const open=!dd.classList.contains('open');closeAllDD();dd.classList.toggle('open',open);e.stopPropagation();return;}
    const pick=e.target.closest('[data-pick]');
    if(pick){state.offer=pick.dataset.pick;renderBundle();}
  });
  document.addEventListener('click',()=>closeAllDD());
}

/* ---------- VARIANT PICKER (swatche nad bundle) ---------- */
function renderVariantPicker(){
  const picker=$('#sx-variant-picker');
  const box=$('#sx-vp-swatches');
  if(!picker || !box) return;
  if(!VARIANTS.length){
    picker.style.display='none';
    return;
  }
  picker.style.display='';
  const activeV=VARIANTS.find(v=>v.id===state.variant)||VARIANTS[0];
  const lbl=$('#sx-vp-name'); if(lbl && activeV) lbl.textContent=activeV.name;
  box.innerHTML=VARIANTS.map(v=>{
    const active=v.id===state.variant;
    // kolor jednolity → kropka; wzór → próbka SVG (v.bg); brak kafla → zdjęcie wariantu → domyślny
    const bgStyle = v.solid ? 'background:'+v.solid
      : (v.bg ? 'background:'+v.bg
      : (v.featuredImage ? 'background-image:url('+v.featuredImage+');background-size:cover;background-position:center'
      : 'background:#EEF4F7'));
    const lightBorder = (v.solid && /^#(f|e)/i.test(v.solid)) ? ';box-shadow:inset 0 0 0 1px rgba(19,32,46,.18)' : '';
    // Prawdziwy <a href>: wzór można otworzyć w nowej karcie, skopiować jego
    // link i zaindeksować. Klik i tak przechwytuje JS, więc bez przeładowania.
    return '<a class="sx-vp-swatch'+(active?' is-active':'')+'" href="'+urlForVariant(v.id, state.size1)+'" data-variant="'+v.id+'" style="'+bgStyle+lightBorder+'" aria-label="'+v.name+'" title="'+v.name+'"></a>';
  }).join('');
  if(box.dataset.wired) return; box.dataset.wired='1';
  box.addEventListener('click',e=>{
    const b=e.target.closest('.sx-vp-swatch'); if(!b)return;
    e.preventDefault();   // próbka jest linkiem — obsługujemy ją w miejscu
    state.variant=b.dataset.variant;
    // wybór koloru na górze ustawia parę #1 na ten kolor i lustrzanie parę #2 (ten sam)
    state.variant2=state.variant;
    state.variants=state.variants||[];
    state.variants[0]=state.variant;
    state.variants[1]=state.variant;
    renderVariantPicker();
    renderBundle();
    const v=VARIANTS.find(x=>x.id===state.variant);
    if(v){
      const lbl=$('#sx-vp-name');if(lbl)lbl.textContent=v.name;
      syncSticky();
      if(VARIANT_GALLERY_ON) renderGalleryForVariant(); else renderHeroSockFallback();
    }
    syncVariantUrl();
    if(USING_REAL_VARIANTS) syncShopifyVariantId();   // ukryte pole wariantu też ma iść za wyborem wzoru
  });
}

/* ---------- Hero gallery: SVG sock fallback if no product image ---------- */
function renderHeroSockFallback(){
  const main=$('#sx-gmain'); if(!main)return;
  if(main.querySelector('.sx-media-fill img, .sx-media-fill video')) return;
  const existing = main.querySelector('.shot-wrap');
  if(existing) existing.remove();
  const v=VARIANTS.find(x=>x.id===state.variant)||VARIANTS[0];
  if(!v||!v.tile) return;
  main.style.background=TINTS[VARIANTS.indexOf(v)%TINTS.length];
  const wrap=document.createElement('div');
  wrap.className='shot-wrap';
  wrap.style.cssText='position:absolute;inset:0;display:grid;place-items:center';
  wrap.innerHTML=shotBlock(state.variant,'');
  main.appendChild(wrap);
}

/* ---------- HIW: tab switching (panels server-rendered) ---------- */
function wireHIW(){
  $$('.sx-hiw-tabs').forEach(tabs=>{
    if(tabs.dataset.wired) return; tabs.dataset.wired='1';
    const sectionId = tabs.dataset.hiw;
    const panels = document.querySelector('[data-hiw-panels="'+sectionId+'"]');
    if(!panels) return;
    const tabBtns = tabs.querySelectorAll('.hiw-tab');
    const panelEls = panels.querySelectorAll('.sx-hiw-panel');
    tabBtns.forEach((btn,i)=>btn.addEventListener('click',()=>{
      tabBtns.forEach(b=>b.classList.remove('is-active'));
      panelEls.forEach(p=>{p.classList.remove('is-active');p.style.display='none';});
      btn.classList.add('is-active');
      if(panelEls[i]){panelEls[i].classList.add('is-active');panelEls[i].style.display='';}
    }));
  });
}

/* ---------- ACCORDION ---------- */
function wireAcc(scope){
  $$('.acc__head',scope||document).forEach(head=>{
    if(head.dataset.wired)return;head.dataset.wired='1';
    head.addEventListener('click',()=>{
      const acc=head.closest('.acc');const body=acc.querySelector('.acc__body');const open=acc.classList.toggle('open');
      head.setAttribute('aria-expanded',open);
      body.style.maxHeight=open?body.scrollHeight+'px':0;
    });
  });
}

/* ---------- TOAST ---------- */
let toastT;
function toast(title,sub){
  let el=$('#sx-toast');
  if(!el){
    el=document.createElement('div');el.id='sx-toast';el.className='sx-pdp-toast';el.setAttribute('role','status');el.setAttribute('aria-live','polite');
    document.body.appendChild(el);
  }
  el.innerHTML='<div class="toast__ico">'+ico('check')+'</div><div><b>'+title+'</b>'+(sub?'<small>'+sub+'</small>':'')+'</div>';
  el.classList.add('show');
  clearTimeout(toastT);toastT=setTimeout(()=>el.classList.remove('show'),2600);
}

/* ---------- ADD TO CART (Shopify Cart AJAX) ---------- */
async function addToCart(e){
  if(e) e.preventDefault();
  const offer=OFFERS.find(o=>o.id===state.offer);
  const ss=state.sizes||[];
  const hasSizes = SIZES.length>0;
  const missing=[];
  if(hasSizes){
    for(let i=0;i<offer.pairs;i++){
      const sz = ss[i] || (i===0?state.size1:(i===1?state.size2:null)) || (SIZES[0] && SIZES[0].id);
      if(!sz) missing.push('size'+i);
    }
  }
  if(missing.length){
    missing.forEach(k=>{const dd=$('#sx-bundle .dd[data-dd="'+k+'"]');if(dd){dd.classList.add('dd__err');const b=dd.querySelector('.dd__btn');if(b){b.classList.add('shake');setTimeout(()=>b.classList.remove('shake'),420);}}});
    toast('Wybierz rozmiar', offer.pairs>1?'Zaznacz rozmiar obu par':'Zaznacz rozmiar pary');
    return;
  }

  const v1=VARIANTS.find(x=>x.id===state.variant), s1=SIZES.find(s=>s.id===state.size1);
  let sub = 'Soxee™ '+(v1?.name||'')+(s1?(' · '+s1.label):'');
  if(offer.pairs>1){
    const v2=VARIANTS.find(x=>x.id===state.variant2), s2=SIZES.find(s=>s.id===state.size2);
    sub = hasSizes
      ? ('Para #1: '+v1?.name+' ('+s1?.label+') + Para #2 GRATIS: '+v2?.name+' ('+s2?.label+')')
      : ('Para #1: '+v1?.name+' + Para #2 GRATIS: '+v2?.name);
  }

  // Real Shopify cart AJAX: dodaj wszystkie pary zestawu (płatne + gratis „te wybrane").
  // Pary gratis (i>=paid) dostają property _gratis; wszystkie linie zestawu spięte _bundle,
  // żeby zmiana ilości / usunięcie w koszyku działały na całą parę. Gratis = 0 zł realizuje
  // AUTOMATYCZNY RABAT Shopify („kup 1, druga gratis") — checkout i drawer pokazują realny stan.
  if(USING_REAL_VARIANTS && VARIANT_LOOKUP){
    const paid = offer.paid || 1;
    const bundleId = 'sx'+Date.now()+Math.floor(Math.random()*1000);
    const items=[]; let allResolved=true;
    for(let i=0;i<offer.pairs;i++){
      const vId=(state.variants&&state.variants[i]) || (i===0?state.variant:(i===1?state.variant2:state.variant)) || (VARIANTS[0]&&VARIANTS[0].id);
      const pv=VARIANTS.find(x=>x.id===vId) || VARIANTS[0];
      let szLabel='';
      if(hasSizes){
        const szId=(state.sizes&&state.sizes[i]) || (i===0?state.size1:(i===1?state.size2:null)) || (SIZES[0]&&SIZES[0].id);
        const sz=SIZES.find(x=>x.id===szId); szLabel = sz?sz.label:'';
      }
      const real=realVariantFor(pv?pv.name:'', szLabel);
      if(!real){ allResolved=false; break; }
      const props={'_zestaw':offer.title};
      if(offer.pairs>1) props['_bundle']=bundleId;
      if(i>=paid) props['_gratis']='GRATIS';
      items.push({id:real.id, quantity:state.qty, properties:props});
    }
    if(allResolved && items.length){
      try{
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        document.dispatchEvent(new CustomEvent('soxee:cart:open'));
        const btn=$('#sx-atc-main');
        if(btn){btn.classList.add('added');const o=btn.textContent;btn.textContent='Dodano!';setTimeout(()=>{btn.classList.remove('added');btn.textContent=o;},1600);}
        return;
      }catch(err){console.warn('Soxee ATC error',err);}
    }
  }

  // fallback (brak realnych wariantów / błąd) — sam komunikat
  toast('Dodano do koszyka', sub);
  const btn=$('#sx-atc-main');
  if(btn){btn.classList.add('added');const original=btn.textContent;btn.textContent='Dodano!';setTimeout(()=>{btn.classList.remove('added');btn.textContent=original;},1600);}
}

/* ---------- STICKY ATC sync ---------- */
function syncSticky(){
  const v=VARIANTS.find(x=>x.id===state.variant);
  const n=$('#sx-sticky-name'); if(n&&v){
    const data=window.__soxeeHeroData;
    const base=data?.title||'Soxee™';
    n.textContent=base+' '+v.name;
  }
}

/* ---------- QTY ---------- */
function wireQty(){
  const inp=$('#sx-qty'),minus=$('#sx-qminus'),plus=$('#sx-qplus'); if(!inp||!minus||minus.dataset.wired)return;
  minus.dataset.wired='1';
  function set(v){state.qty=Math.max(1,Math.min(9,v));inp.value=state.qty;minus.disabled=state.qty<=1;}
  minus.addEventListener('click',()=>set(state.qty-1));
  plus.addEventListener('click',()=>set(state.qty+1));
  inp.addEventListener('change',()=>set(parseInt(inp.value)||1));
  set(parseInt(inp.value)||1);
}

/* ---------- NEWSLETTER form fallback ---------- */
function wireNewsletter(){
  const f=$('#sx-nl-form'); if(!f||f.dataset.wired)return;f.dataset.wired='1';
  f.addEventListener('submit',e=>{e.preventDefault();toast('Zapisano!','Sprawdź skrzynkę — rabat już leci do Ciebie');f.reset();});
}

/* ---------- INIT ---------- */
function init(){
  $$('[data-ico]').forEach(el=>{if(el.dataset.icoInit)return;el.dataset.icoInit='1';el.innerHTML=ico(el.dataset.ico);});
  const s=ico('star','ico--fill');
  const h=$('#sx-hero-stars');if(h&&!h.dataset.init){h.dataset.init='1';h.innerHTML=s.repeat(5);}
  const r=$('#sx-rev-stars');if(r&&!r.dataset.init){r.dataset.init='1';r.innerHTML=s.repeat(5);}

  // PDP gallery: wire thumbnails to swap the main image
  const gthumbs=$('#sx-gthumbs');
  if(gthumbs && !gthumbs.dataset.wired){
    gthumbs.dataset.wired='1';
    gthumbs.addEventListener('click',e=>{
      const t=e.target.closest('.thumb');if(!t)return;
      const full=t.dataset.full; if(!full) return;
      gthumbs.querySelectorAll('.thumb').forEach(x=>x.classList.remove('is-active'));
      t.classList.add('is-active');
      const main=$('#sx-gmain');if(!main)return;
      // ensure media-fill wrapper exists
      let fill=main.querySelector('.sx-media-fill');
      if(!fill){
        // remove sock SVG fallback if present
        main.querySelector('.shot-wrap')?.remove();
        fill=document.createElement('div');fill.className='sx-media-fill';
        main.appendChild(fill);
      }
      setMainImage(fill, full, t.dataset.alt||'');
    });
  }

  // homepage: hydrate sock SVGs for pattern cards without uploaded image
  $$('.sx-card-shot[data-variant]').forEach(el=>{
    if(el.dataset.init)return;el.dataset.init='1';
    el.innerHTML = shotBlock(el.dataset.variant, '');
  });
  // banner stars
  $$('[data-sx-stars-fill]').forEach(el=>{
    if(el.dataset.init)return;el.dataset.init='1';
    const n=parseInt(el.dataset.sxStarsFill)||5;
    el.innerHTML=ico('star','ico--fill').repeat(n);
  });

  if(VARIANT_GALLERY_ON) renderGalleryForVariant(); else renderHeroSockFallback();
  renderVariantPicker();
  renderBundle();wireBundleOnce();
  const titleName=$('#sx-ptitle-name');if(titleName&&!titleName.dataset.init&&VARIANTS[0]){titleName.dataset.init='1';titleName.textContent='— '+VARIANTS[0].name;}
  syncSticky();

  wireHIW();
  wireAcc(document);
  wireQty();
  wireNewsletter();

  const formMain=$('#sx-product-form');
  if(formMain&&!formMain.dataset.wired){formMain.dataset.wired='1';formMain.addEventListener('submit',addToCart);}
  $('#sx-atc-main')?.addEventListener('click',e=>{ if(!formMain) addToCart(e); });
  $('#sx-atc-sticky')?.addEventListener('click',addToCart);

  $$('[data-scroll]').forEach(a=>{
    if(a.dataset.scrollWired)return;a.dataset.scrollWired='1';
    a.addEventListener('click',e=>{e.preventDefault();const t=document.querySelector(a.getAttribute('data-scroll'));t&&window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'});});
  });

  const sentinel=$('#sx-buybox');const bar=$('#sx-sticky-atc');
  if(sentinel&&bar&&'IntersectionObserver'in window&&!bar.dataset.obs){
    bar.dataset.obs='1';
    new IntersectionObserver(([e])=>{bar.classList.toggle('show',!e.isIntersecting && e.boundingClientRect.top<0);},{threshold:0}).observe(sentinel);
  }
}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
document.addEventListener('shopify:section:load',init);

})();
